console.log('%c[Limited] CUSTOM JS CARGADO v2100', 'background:#111;color:#f5d400;font-size:16px;font-weight:bold;padding:4px 8px;');

/* =========================================================
 * LIMITED - Variant Wizard / ProductWiz Rio + Broadcast
 * v2100
 *
 * Objetivos:
 * - Mantener la combinación EXACTA elegida por el cliente.
 * - No saltar silenciosamente entre variantes (ej. Con/Sin Monedero).
 * - Mantener sincronizados ID de variante, imagen, precio y stock.
 * - Evitar que sincronizaciones antiguas pisen un clic más reciente.
 * ========================================================= */

(function () {
  if (window.__limitedPwzrBroadcastBridgeV2100) return;
  window.__limitedPwzrBroadcastBridgeV2100 = true;

  var PRODUCT_ROOT = '[data-section-type="product"][data-product-handle]';

  function normalizeText(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function getRoot(target) {
    if (target && target.closest) {
      var closest = target.closest(PRODUCT_ROOT);
      if (closest) return closest;
    }

    return document.querySelector(PRODUCT_ROOT);
  }

  function getProductJson(root) {
    if (!root) return null;

    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return null;

    try {
      return JSON.parse(jsonEl.textContent);
    } catch (error) {
      console.warn('[Limited] No se pudo leer data-product-json', error);
      return null;
    }
  }

  function getVariantById(product, variantId) {
    if (!product || !product.variants || !variantId) return null;

    return product.variants.find(function (variant) {
      return String(variant.id) === String(variantId);
    }) || null;
  }

  function getPrimaryVariantInput(root) {
    if (!root) return null;

    return (
      root.querySelector('[data-form-wrapper] input[name="id"]') ||
      root.querySelector('input[name="id"], select[name="id"]')
    );
  }

  function getCurrentVariantFromInputs(root) {
    var product = getProductJson(root);
    if (!product || !product.variants) return null;

    var primaryInput = getPrimaryVariantInput(root);

    if (primaryInput && primaryInput.value) {
      var primaryVariant = getVariantById(product, primaryInput.value);

      if (primaryVariant) {
        return primaryVariant;
      }
    }

    var inputs = Array.prototype.slice.call(
      root.querySelectorAll('input[name="id"], select[name="id"]')
    );

    for (var i = 0; i < inputs.length; i++) {
      var variant = getVariantById(product, inputs[i].value);

      if (variant) {
        return variant;
      }
    }

    var urlVariant = new URLSearchParams(window.location.search).get('variant');

    if (urlVariant) {
      return getVariantById(product, urlVariant);
    }

    return product.variants[0] || null;
  }

  function getClickedOptionValue(target) {
    if (!target || !target.closest) return null;

    var optionButton = target.closest('[data-option-value]');

    if (optionButton) {
      return optionButton.getAttribute('data-option-value');
    }

    var ariaButton = target.closest('[role="button"][aria-label]');

    if (ariaButton) {
      return ariaButton.getAttribute('aria-label');
    }

    return null;
  }

  function getClickedOptionName(target) {
    if (!target || !target.closest) return null;

    var optionGroup = target.closest('[data-option]');

    if (optionGroup) {
      return optionGroup.getAttribute('data-option');
    }

    var namedGroup = target.closest('[data-option-name]');

    if (namedGroup) {
      return namedGroup.getAttribute('data-option-name');
    }

    return null;
  }

  function getOptionIndex(product, optionName, optionValue) {
    if (!product) return -1;

    var options = product.options || [];

    if (optionName) {
      var normalizedName = normalizeText(optionName);

      for (var i = 0; i < options.length; i++) {
        var option = options[i];
        var name = typeof option === 'string' ? option : option.name;

        if (normalizeText(name) === normalizedName) {
          return i;
        }
      }
    }

    /*
     * Respaldo para ProductWiz:
     * si no entrega el nombre del grupo, detectamos en qué posición
     * de las variantes existe el valor clickeado.
     */
    if (optionValue) {
      var normalizedValue = normalizeText(optionValue);
      var matchingIndexes = [];

      for (var j = 0; j < options.length; j++) {
        var existsInOption = product.variants.some(function (variant) {
          return normalizeText(variant.options[j]) === normalizedValue;
        });

        if (existsInOption) {
          matchingIndexes.push(j);
        }
      }

      if (matchingIndexes.length === 1) {
        return matchingIndexes[0];
      }
    }

    return -1;
  }

  function findVariantBySelectedOptions(product, selectedOptions) {
    if (!product || !product.variants || !selectedOptions) return null;

    return product.variants.find(function (variant) {
      return variant.options.every(function (option, index) {
        return (
          normalizeText(option) ===
          normalizeText(selectedOptions[index])
        );
      });
    }) || null;
  }

  function updateVariantInputs(root, variant) {
    if (!root || !variant || !variant.id) return;

    var inputs = root.querySelectorAll(
      'input[name="id"], select[name="id"]'
    );

    inputs.forEach(function (input) {
      if (String(input.value) !== String(variant.id)) {
        input.value = variant.id;

        input.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }
    });

    try {
      var url = new URL(window.location.href);

      url.searchParams.set(
        'variant',
        variant.id
      );

      window.history.replaceState(
        {
          path: url.toString()
        },
        '',
        url.toString()
      );
    } catch (error) {}
  }

  function switchBroadcastMedia(root, variant) {
    if (!root || !variant) return;

    var productImages = root.querySelector('product-images');

    if (!productImages) return;

    var mediaId = null;

    if (
      variant.featured_media &&
      variant.featured_media.id
    ) {
      mediaId = variant.featured_media.id;
    } else if (
      variant.featured_image &&
      variant.featured_image.id
    ) {
      mediaId = variant.featured_image.id;
    }

    if (!mediaId) return;

    var slide = root.querySelector(
      '[data-image-id="' + mediaId + '"]'
    );

    if (!slide) return;

    var mediaKey = slide.getAttribute('data-media-id');

    if (!mediaKey) return;

    if (
      typeof productImages.setActiveMedia ===
      'function'
    ) {
      productImages.setActiveMedia(mediaKey);
    } else {
      slide.dispatchEvent(
        new CustomEvent(
          'theme:media:select',
          {
            bubbles: true,
            detail: {
              id: mediaKey
            }
          }
        )
      );
    }
  }

  function dispatchVariantSync(root, variant) {
    if (!root || !variant) return;

    document.dispatchEvent(
      new CustomEvent(
        'limited:variant:sync',
        {
          bubbles: true,
          detail: {
            variant: variant,
            root: root
          }
        }
      )
    );
  }

  function isVariantStillCurrentOrExpected(
    root,
    variant
  ) {
    if (!root || !variant) return false;

    if (
      root.__limitedExpectedVariantId &&
      root.__limitedExpectedVariantUntil &&
      Date.now() <
        root.__limitedExpectedVariantUntil
    ) {
      return (
        String(
          root.__limitedExpectedVariantId
        ) === String(variant.id)
      );
    }

    var current =
      getCurrentVariantFromInputs(root);

    return (
      !!current &&
      String(current.id) ===
        String(variant.id)
    );
  }

  function syncVariant(root, variant) {
    if (!root || !variant) return;

    if (variant.options) {
      root.__limitedSelectedOptions =
        variant.options.slice();
    }

    /*
     * Primero notificamos al precio,
     * badges y Stock Guard.
     */
    dispatchVariantSync(
      root,
      variant
    );

    /*
     * Después sincronizamos Shopify
     * y la imagen.
     */
    updateVariantInputs(
      root,
      variant
    );

    switchBroadcastMedia(
      root,
      variant
    );

    /*
     * Última notificación.
     * Sólo si sigue siendo la variante vigente.
     */
    setTimeout(function () {
      if (
        isVariantStillCurrentOrExpected(
          root,
          variant
        )
      ) {
        dispatchVariantSync(
          root,
          variant
        );
      }
    }, 140);
  }

  function syncFromCurrentInput(target) {
    var root =
      getRoot(target);

    if (!root) return;

    var variant =
      getCurrentVariantFromInputs(
        root
      );

    if (!variant) return;

    /*
     * ProductWiz puede escribir momentáneamente
     * otro ID mientras procesa el clic.
     *
     * Durante ese período sólo aceptamos
     * la variante exacta esperada.
     */
    if (
      root.__limitedExpectedVariantId &&
      root.__limitedExpectedVariantUntil &&
      Date.now() <
        root.__limitedExpectedVariantUntil &&
      String(variant.id) !==
        String(
          root.__limitedExpectedVariantId
        )
    ) {
      return;
    }

    if (variant.options) {
      root.__limitedSelectedOptions =
        variant.options.slice();
    }

    switchBroadcastMedia(
      root,
      variant
    );

    dispatchVariantSync(
      root,
      variant
    );
  }

  function delayedSyncFromClick(target) {
    var root =
      getRoot(target);

    if (!root) return;

    var product =
      getProductJson(root);

    if (
      !product ||
      !product.variants
    ) {
      return;
    }

    /*
     * Estamos escuchando el clic en capture.
     *
     * Esto significa que todavía tenemos
     * la variante REAL seleccionada antes
     * de que ProductWiz modifique los inputs.
     */
    var currentVariant =
      getCurrentVariantFromInputs(
        root
      );

    var optionValue =
      getClickedOptionValue(
        target
      );

    var optionName =
      getClickedOptionName(
        target
      );

    if (
      !currentVariant ||
      !currentVariant.options ||
      !optionValue
    ) {
      return;
    }

    /*
     * Partimos SIEMPRE de la variante
     * actualmente seleccionada.
     */
    var selectedOptions =
      currentVariant.options.slice();

    var optionIndex =
      getOptionIndex(
        product,
        optionName,
        optionValue
      );

    /*
     * Si no podemos demostrar qué opción
     * cambió, no hacemos nada.
     *
     * Es preferible dejar trabajar al tema
     * antes que inventar una variante.
     */
    if (optionIndex < 0) {
      return;
    }

    /*
     * Cambiamos EXCLUSIVAMENTE
     * la opción que el cliente pinchó.
     *
     * Ejemplo:
     *
     * Black / Sin Monedero
     * +
     * Dark Brown
     *
     * =
     *
     * Dark Brown / Sin Monedero
     */
    selectedOptions[
      optionIndex
    ] = optionValue;

    /*
     * Buscamos esa combinación EXACTA.
     *
     * Ya NO existe ningún fallback
     * que cambie a una variante disponible
     * diferente.
     */
    var expectedVariant =
      findVariantBySelectedOptions(
        product,
        selectedOptions
      );

    if (!expectedVariant) {
      return;
    }

    /*
     * Cada nuevo clic invalida todas las
     * sincronizaciones del clic anterior.
     */
    root.__limitedClickSequence =
      (
        root.__limitedClickSequence ||
        0
      ) + 1;

    var sequence =
      root.__limitedClickSequence;

    root.__limitedExpectedVariantId =
      String(
        expectedVariant.id
      );

    root.__limitedExpectedVariantUntil =
      Date.now() + 1100;

    /*
     * Repetimos la MISMA variante exacta.
     *
     * Esto sirve para ganar posibles carreras
     * contra ProductWiz y Broadcast,
     * sin recalcular la combinación.
     */
    [
      0,
      80,
      220,
      450
    ].forEach(
      function (delay) {
        setTimeout(
          function () {
            if (
              root.__limitedClickSequence !==
              sequence
            ) {
              return;
            }

            syncVariant(
              root,
              expectedVariant
            );
          },
          delay
        );
      }
    );

    /*
     * Cuando termina el período de transición
     * volvemos al comportamiento normal.
     */
    setTimeout(
      function () {
        if (
          root.__limitedClickSequence !==
          sequence
        ) {
          return;
        }

        if (
          String(
            root.__limitedExpectedVariantId
          ) ===
          String(
            expectedVariant.id
          )
        ) {
          root.__limitedExpectedVariantId =
            null;

          root.__limitedExpectedVariantUntil =
            0;
        }
      },
      1150
    );
  }

  /*
   * ProductWiz / Variant Wizard.
   */
  document.addEventListener(
    'click',
    function (event) {
      if (
        !event.target ||
        !event.target.closest
      ) {
        return;
      }

      var target =
        event.target.closest(
          '[class*="Pwzr"], [data-option-value], [role="button"][aria-label]'
        );

      if (!target) return;

      delayedSyncFromClick(
        target
      );
    },
    true
  );

  /*
   * Inputs nativos / Broadcast.
   */
  document.addEventListener(
    'change',
    function (event) {
      if (
        !event.target ||
        !event.target.matches
      ) {
        return;
      }

      if (
        event.target.matches(
          'input[name="id"], select[name="id"], [data-single-option-selector]'
        )
      ) {
        setTimeout(
          function () {
            syncFromCurrentInput(
              event.target
            );
          },
          120
        );
      }
    },
    true
  );

  function initBridge() {
    document
      .querySelectorAll(
        PRODUCT_ROOT
      )
      .forEach(
        function (root) {
          var variant =
            getCurrentVariantFromInputs(
              root
            );

          if (!variant) return;

          if (variant.options) {
            root.__limitedSelectedOptions =
              variant.options.slice();
          }

          switchBroadcastMedia(
            root,
            variant
          );

          dispatchVariantSync(
            root,
            variant
          );
        }
      );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initBridge
    );
  } else {
    initBridge();
  }

  window.addEventListener(
    'load',
    initBridge
  );

  document.addEventListener(
    'shopify:section:load',
    function () {
      initBridge();
    }
  );
})();


/* =========================================================
 * LIMITED - Stock Guard
 * v2100
 *
 * Objetivos:
 * - Variante normal sin stock:
 *      AGOTADO + botón deshabilitado.
 *
 * - Variante normal con stock:
 *      compra habilitada normalmente.
 *
 * - Si otra app vuelve a habilitar
 *   una variante realmente agotada,
 *   se corrige.
 *
 * - Una PREVENTA real sigue quedando
 *   bajo control de Essential/tema.
 * ========================================================= */

(function () {
  if (
    window.__limitedStockGuardV2100
  ) {
    return;
  }

  window.__limitedStockGuardV2100 =
    true;

  var PRODUCT_ROOT =
    '[data-section-type="product"][data-product-handle]';

  var MAIN_BUTTON =
    'button[name="add"][data-add-to-cart]';

  var STICKY_BUTTON =
    'button[data-add-to-cart-bar]';

  var BUTTON_SELECTOR =
    MAIN_BUTTON +
    ', ' +
    STICKY_BUTTON;

  var TEXT_SELECTOR =
    '[data-add-to-cart-text]';


  function normalizeText(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }


  function getProduct(root) {
    if (!root) return null;

    var json =
      root.querySelector(
        '[data-product-json]'
      );

    if (!json) return null;

    try {
      return JSON.parse(
        json.textContent
      );
    } catch (error) {
      return null;
    }
  }


  function getCurrentVariant(root) {
    var product =
      getProduct(root);

    if (
      !product ||
      !product.variants
    ) {
      return null;
    }

    var input =
      root.querySelector(
        '[data-form-wrapper] input[name="id"]'
      ) ||
      root.querySelector(
        'input[name="id"], select[name="id"]'
      );

    if (
      !input ||
      !input.value
    ) {
      return null;
    }

    return product.variants.find(
      function (variant) {
        return (
          String(variant.id) ===
          String(input.value)
        );
      }
    ) || null;
  }


  function getSoldOutText() {
    if (
      window.theme &&
      window.theme.strings &&
      window.theme.strings.soldOut
    ) {
      return (
        window.theme.strings.soldOut
      );
    }

    return 'Agotado';
  }


  function getAddToCartText() {
    if (
      window.theme &&
      window.theme.strings &&
      window.theme.strings.addToCart
    ) {
      return (
        window.theme.strings.addToCart
      );
    }

    return 'Agregar al carrito';
  }


  function textLooksLikePreorder(
    text
  ) {
    var value =
      normalizeText(text);

    return (
      value.indexOf(
        'preorder'
      ) !== -1 ||
      value.indexOf(
        'pre-order'
      ) !== -1 ||
      value.indexOf(
        'pre order'
      ) !== -1 ||
      value.indexOf(
        'preventa'
      ) !== -1 ||
      value.indexOf(
        'pre-venta'
      ) !== -1 ||
      value.indexOf(
        'pre venta'
      ) !== -1 ||
      value.indexOf(
        'preorden'
      ) !== -1 ||
      value.indexOf(
        'pre-orden'
      ) !== -1 ||
      value.indexOf(
        'pre orden'
      ) !== -1 ||
      value.indexOf(
        'reservar'
      ) !== -1
    );
  }


  function isPreorderContext(root) {
    if (!root) return false;

    /*
     * Preventa configurada directamente
     * en el tema.
     */
    if (
      root.querySelector(
        '[data-product-preorder]'
      )
    ) {
      return true;
    }

    /*
     * Essential y otras apps cambian
     * normalmente el texto cuando están
     * gestionando realmente una preventa.
     */
    var buttons =
      root.querySelectorAll(
        BUTTON_SELECTOR
      );

    for (
      var i = 0;
      i < buttons.length;
      i++
    ) {
      if (
        textLooksLikePreorder(
          buttons[i].textContent
        )
      ) {
        return true;
      }
    }

    return false;
  }


  function lockSoldOut(
    root,
    variant
  ) {
    if (
      !root ||
      !variant ||
      variant.available !== false
    ) {
      return;
    }

    /*
     * Si Essential/tema está gestionando
     * realmente una preventa, no intervenimos.
     */
    if (
      isPreorderContext(root)
    ) {
      releaseLimitedLock(
        root,
        variant,
        true
      );

      return;
    }

    root.__limitedStockVariant =
      variant;

    root.__limitedStockVariantId =
      String(variant.id);

    var wrapper =
      root.querySelector(
        '[data-form-wrapper]'
      );

    if (
      wrapper &&
      !wrapper.classList.contains(
        'variant--soldout'
      )
    ) {
      wrapper.classList.add(
        'variant--soldout'
      );
    }

    root
      .querySelectorAll(
        BUTTON_SELECTOR
      )
      .forEach(
        function (button) {
          button.setAttribute(
            'data-limited-stock-lock',
            'true'
          );

          if (!button.disabled) {
            button.disabled = true;
          }

          if (
            !button.hasAttribute(
              'disabled'
            )
          ) {
            button.setAttribute(
              'disabled',
              'disabled'
            );
          }

          if (
            button.getAttribute(
              'aria-disabled'
            ) !== 'true'
          ) {
            button.setAttribute(
              'aria-disabled',
              'true'
            );
          }

          var text =
            button.querySelector(
              TEXT_SELECTOR
            );

          var soldOutText =
            getSoldOutText();

          if (
            text &&
            normalizeText(
              text.textContent
            ) !==
              normalizeText(
                soldOutText
              )
          ) {
            text.textContent =
              soldOutText;
          }
        }
      );
  }


  function releaseLimitedLock(
    root,
    variant,
    preorderMode
  ) {
    if (!root) return;

    if (
      variant &&
      variant.id
    ) {
      root.__limitedStockVariant =
        variant;

      root.__limitedStockVariantId =
        String(variant.id);
    }

    var wrapper =
      root.querySelector(
        '[data-form-wrapper]'
      );

    if (wrapper) {
      wrapper.classList.remove(
        'variant--soldout'
      );
    }

    root
      .querySelectorAll(
        BUTTON_SELECTOR
      )
      .forEach(
        function (button) {
          if (
            button.hasAttribute(
              'data-limited-stock-lock'
            )
          ) {
            button.removeAttribute(
              'data-limited-stock-lock'
            );

            button.removeAttribute(
              'aria-disabled'
            );

            button.disabled =
              false;

            button.removeAttribute(
              'disabled'
            );
          }
        }
      );

    /*
     * En preventa dejamos 100%
     * el texto en manos de Essential.
     */
    if (
      preorderMode ||
      !variant ||
      variant.available !== true
    ) {
      return;
    }

    /*
     * Si veníamos desde una agotada
     * y quedó pegado el texto AGOTADO,
     * Broadcast tiene primero oportunidad
     * de corregirlo.
     *
     * Este es sólo el respaldo.
     */
    var variantId =
      String(variant.id);

    setTimeout(
      function () {
        if (
          root.__limitedStockVariantId !==
          variantId
        ) {
          return;
        }

        if (
          isPreorderContext(root)
        ) {
          return;
        }

        root
          .querySelectorAll(
            BUTTON_SELECTOR
          )
          .forEach(
            function (button) {
              var text =
                button.querySelector(
                  TEXT_SELECTOR
                );

              if (
                text &&
                normalizeText(
                  text.textContent
                ) ===
                  normalizeText(
                    getSoldOutText()
                  )
              ) {
                text.textContent =
                  getAddToCartText();
              }
            }
          );
      },
      180
    );
  }


  function applyVariantState(
    root,
    variant
  ) {
    if (
      !root ||
      !variant
    ) {
      return;
    }

    root.__limitedStockVariant =
      variant;

    root.__limitedStockVariantId =
      String(variant.id);

    if (
      variant.available === false
    ) {
      lockSoldOut(
        root,
        variant
      );
    } else {
      releaseLimitedLock(
        root,
        variant,
        false
      );
    }
  }


  function scheduleVariantState(
    root,
    variant
  ) {
    if (
      !root ||
      !variant ||
      !variant.id
    ) {
      return;
    }

    var variantId =
      String(variant.id);

    root.__limitedStockVariant =
      variant;

    root.__limitedStockVariantId =
      variantId;

    root.__limitedStockSequence =
      (
        root.__limitedStockSequence ||
        0
      ) + 1;

    var sequence =
      root.__limitedStockSequence;

    /*
     * Reforzamos el estado durante el
     * período en que Broadcast,
     * ProductWiz o Essential podrían
     * volver a tocar el botón.
     */
    [
      0,
      60,
      160,
      320,
      650,
      1000
    ].forEach(
      function (delay) {
        setTimeout(
          function () {
            if (
              root.__limitedStockSequence !==
              sequence
            ) {
              return;
            }

            if (
              root.__limitedStockVariantId !==
              variantId
            ) {
              return;
            }

            applyVariantState(
              root,
              variant
            );
          },
          delay
        );
      }
    );
  }


  /*
   * Evento de nuestro bridge
   * ProductWiz/Broadcast.
   */
  document.addEventListener(
    'limited:variant:sync',
    function (event) {
      if (
        !event.detail ||
        !event.detail.variant
      ) {
        return;
      }

      var root =
        event.detail.root;

      if (!root) {
        root =
          document.querySelector(
            PRODUCT_ROOT
          );
      }

      if (!root) return;

      scheduleVariantState(
        root,
        event.detail.variant
      );
    }
  );


  /*
   * Evento nativo Broadcast.
   */
  document.addEventListener(
    'theme:variant:change',
    function (event) {
      if (
        !event.detail ||
        !event.detail.variant
      ) {
        return;
      }

      var root = null;

      if (
        event.target &&
        event.target.closest
      ) {
        root =
          event.target.closest(
            PRODUCT_ROOT
          );
      }

      if (!root) {
        root =
          document.querySelector(
            PRODUCT_ROOT
          );
      }

      if (!root) return;

      scheduleVariantState(
        root,
        event.detail.variant
      );
    }
  );


  /*
   * Respaldo sobre el ID real.
   */
  document.addEventListener(
    'change',
    function (event) {
      if (
        !event.target ||
        !event.target.matches
      ) {
        return;
      }

      if (
        !event.target.matches(
          'input[name="id"], select[name="id"], [data-single-option-selector]'
        )
      ) {
        return;
      }

      var root =
        event.target.closest
          ? event.target.closest(
              PRODUCT_ROOT
            )
          : null;

      if (!root) {
        root =
          document.querySelector(
            PRODUCT_ROOT
          );
      }

      if (!root) return;

      setTimeout(
        function () {
          var variant =
            getCurrentVariant(
              root
            );

          if (variant) {
            scheduleVariantState(
              root,
              variant
            );
          }
        },
        100
      );
    },
    true
  );


  /*
   * Si otra app intenta tocar el botón
   * después, verificamos nuevamente.
   */
  function installObserver(root) {
    if (
      !root ||
      root.__limitedStockObserver
    ) {
      return;
    }

    var scheduled =
      false;

    var observer =
      new MutationObserver(
        function () {
          if (scheduled) {
            return;
          }

          scheduled =
            true;

          requestAnimationFrame(
            function () {
              scheduled =
                false;

              var variant =
                root.__limitedStockVariant ||
                getCurrentVariant(
                  root
                );

              if (!variant) {
                return;
              }

              /*
               * Si Essential convirtió
               * realmente el botón en
               * PREORDER/PREVENTA,
               * dejamos de imponer agotado.
               */
              if (
                variant.available ===
                  false &&
                isPreorderContext(
                  root
                )
              ) {
                releaseLimitedLock(
                  root,
                  variant,
                  true
                );

                return;
              }

              if (
                variant.available ===
                false
              ) {
                lockSoldOut(
                  root,
                  variant
                );
              }
            }
          );
        }
      );

    observer.observe(
      root,
      {
        subtree: true,
        childList: true,
        attributes: true,
        characterData: true,
        attributeFilter: [
          'disabled',
          'class',
          'aria-disabled'
        ]
      }
    );

    root.__limitedStockObserver =
      observer;
  }


  function initStockGuard() {
    document
      .querySelectorAll(
        PRODUCT_ROOT
      )
      .forEach(
        function (root) {
          installObserver(
            root
          );

          var variant =
            getCurrentVariant(
              root
            );

          if (variant) {
            scheduleVariantState(
              root,
              variant
            );
          }
        }
      );
  }


  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initStockGuard
    );
  } else {
    initStockGuard();
  }

  window.addEventListener(
    'load',
    initStockGuard
  );

  document.addEventListener(
    'shopify:section:load',
    function () {
      initStockGuard();
    }
  );
})();


/* =========================================================
 * Scroll suave a formulario corporativo
 * ========================================================= */

(function () {
  var scrollInitialized = false;

  function initScroll() {
    if (scrollInitialized) return;

    var fb =
      document.querySelector(
        '.globo-formbuilder-wizard, .globo-formbuilder'
      );

    if (!fb) {
      if (
        (initScroll.attempts || 0) <
        10
      ) {
        initScroll.attempts =
          (
            initScroll.attempts ||
            0
          ) + 1;

        setTimeout(
          initScroll,
          300
        );
      }

      return;
    }

    scrollInitialized = true;

    if (!fb.id) {
      fb.id =
        'formulario-corporativo';
    }

    document.addEventListener(
      'click',
      function (event) {
        if (
          !event.target ||
          !event.target.closest
        ) {
          return;
        }

        var link =
          event.target.closest(
            'a[href="#formulario-corporativo"]'
          );

        if (!link) return;

        event.preventDefault();

        fb.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    );
  }

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initScroll
    );
  } else {
    initScroll();
  }
})();